import { useConfirmation } from "src/sudokit/components/ConfirmationDialog/ConfirmationProvider";
import { StyledContainer } from "./styles";
import { useState } from "react";
import { useParams } from "react-router-dom";
import Utils, { makeId } from "../../../Utils";
import Modal from "react-modal";
import { ENGINES } from "..";
import Select from "react-select";
import moment from "moment";
import { adminRecords } from "../../../admin/adminRecords";
import Auth from "../../../Auth";
import { useImmer } from "use-immer";

Modal.setAppElement("#root");

const STRIDES = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
];

const ENDPOINTS = [
  { value: "synopsis", label: "Synopsis" },
  { value: "characters", label: "Characters" },
  { value: "commmands", label: "Beats" },
  { value: "outlineV2", label: "Outline" },
  { value: "write/most-accurate", label: "Write - Most Accurate" },
  { value: "write/best-prose", label: "Write - Best Prose" },
  { value: "write/fastest", label: "Write - Fastest" },
];

function generateRandomWords() {
  const words = [
    "Lorem",
    "ipsum",
    "dolor",
    "sit",
    "amet",
    "consectetur",
    "adipiscing",
    "elit",
    "sed",
    "do",
    "eiusmod",
    "tempor",
    "incididunt",
    "ut",
    "labore",
    "et",
    "dolore",
    "magna",
    "aliqua",
    "Ut",
    "enim",
    "ad",
    "minim",
    "veniam",
    "quis",
    "nostrud",
    "exercitation",
    "ullamco",
    "laboris",
    "nisi",
    "ut",
    "aliquip",
    "ex",
    "ea",
    "commodo",
    "consequat",
    "Duis",
    "aute",
    "irure",
    "dolor",
    "in",
    "reprehenderit",
    "in",
    "voluptate",
    "velit",
    "esse",
    "cillum",
    "dolore",
    "eu",
    "fugiat",
    "nulla",
    "pariatur",
    "Excepteur",
    "sint",
    "occaecat",
    "cupidatat",
    "non",
    "proident",
    "sunt",
    "in",
    "culpa",
    "qui",
    "officia",
    "deserunt",
    "mollit",
    "anim",
    "id",
    "est",
    "laborum",
  ];

  let randomWords = "";
  for (let i = 0; i < 2000; i++) {
    const randomIndex = Math.floor(Math.random() * words.length);
    randomWords += words[randomIndex] + " ";
  }
  return randomWords.trim();
}

function generateRandomList() {
  const words = [
    "Lorem",
    "ipsum",
    "dolor",
    "sit",
    "amet",
    "consectetur",
    "adipiscing",
    "elit",
    "sed",
    "do",
    "eiusmod",
    "tempor",
    "incididunt",
    "ut",
    "labore",
    "et",
    "dolore",
    "magna",
    "aliqua",
    "Ut",
    "enim",
    "ad",
    "minim",
    "veniam",
    "quis",
    "nostrud",
    "exercitation",
    "ullamco",
    "laboris",
    "nisi",
    "ut",
    "aliquip",
    "ex",
    "ea",
    "commodo",
    "consequat",
    "Duis",
    "aute",
    "irure",
    "dolor",
    "in",
    "reprehenderit",
    "in",
    "voluptate",
    "velit",
    "esse",
    "cillum",
    "dolore",
    "eu",
    "fugiat",
    "nulla",
    "pariatur",
    "Excepteur",
    "sint",
    "occaecat",
    "cupidatat",
    "non",
    "proident",
    "sunt",
    "in",
    "culpa",
    "qui",
    "officia",
    "deserunt",
    "mollit",
    "anim",
    "id",
    "est",
    "laborum",
  ];

  let randomList = "";
  for (let i = 1; i <= 12; i++) {
    const randomIndex = Math.floor(Math.random() * words.length);
    randomList += `${i}. ${words[randomIndex]}${i !== 12 ? "\n" : ""}`;
  }
  return randomList;
}

export default function AdminMenu({
  stride,
  setStride,
  scenes,
  setScenes,
  invocations,
  open,
  close,
  setEngine,
  engine,
  setSeed,
  setGenre,
  setStyle,
  setCharacters,
  setOutline,
  setSynopsis,
  setMetadata,
  currentStoryEngine,
}) {
  const confirmAction = useConfirmation();
  const customStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(55, 55, 55, 0.7)",
      zIndex: "100000001",
    },
    content: {
      top: "10%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      zIndex: "20000",
      width: "750px",
      transform: "translate(-50%, 0)",
      borderRadius: "15px",
      border: "0px",
      padding: "0px",
      background: "#f5f2e4",
      boxShadow: "var(--default-drop-shadow)",
    },
  };
  const { projectId } = useParams();
  const [userInvocationId, setUserInvocationId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [userStoryEngine, setUserStoryEngine] = useState("");
  const [importedStoryEngine, setImportedStoryEngine] = useState("");
  const [numFunctionsToTest, setNumFunctionsToTest] = useState(1);
  const [testResults, setTestResults] = useImmer({});
  const [endpoint, setEndpoint] = useState();

  const loadInvocation = async () => {
    setErrorMessage("");
    console.log("Invocation loading", userInvocationId);
    const data = (await adminRecords.collection("invocations").doc(userInvocationId).get()).data();
    if (!data) {
      setErrorMessage("Invocation not found with that id");
      return;
    }
    if (!data.context?.storyEngine) {
      setErrorMessage("No storyEngine for that invocation id");
      return;
    }

    const storyEngine = data.context.storyEngine;

    setUserStoryEngine(storyEngine);
    console.log("Invocation loaded", data);
  };

  const pasteStoryEngine = (imported = null) => {
    const storyEngine = imported ? JSON.parse(imported) : userStoryEngine;
    setSeed(storyEngine.seed);
    setGenre(storyEngine.metadata?.genre);
    setStyle(storyEngine.metadata?.style);
    setSynopsis(storyEngine.synopsis, projectId);
    setCharacters(storyEngine.characters);
    setOutline(storyEngine.outline);
    setScenes(storyEngine.scenes);
    close();
  };

  const testFunctions = async (num, endpoint) => {
    setTestResults({});
    const promises = [];

    for (var i = 0; i < num; i++) {
      promises.push(() =>
        Auth.streamWithIdToken(`/api/ai/storyEngine/${endpoint.value}`, userStoryEngine, null, (chunk, streamId) => {
          if (!chunk.text) return;
          setTestResults((draft) => {
            draft[streamId] = draft[streamId] ? draft[streamId] + chunk.text : chunk.text;
          });
        })
      );
    }

    const res = await Promise.all(promises.map((func) => func()));
  };

  return (
    <Modal
      isOpen={open}
      // contentRef={(node) => (ref.current = node)}
      style={customStyles}
    >
      <StyledContainer>
        <h2>Admin</h2>

        <br />

        <h3>Override Engine</h3>
        <Select
          className={"select"}
          value={engine}
          onChange={(selectedOption) => {
            setEngine(selectedOption);
          }}
          options={ENGINES}
        />

        <br />

        <h3>Override Stride</h3>
        <Select
          className={"select"}
          value={stride}
          onChange={(selectedOption) => {
            setStride(selectedOption);
          }}
          options={STRIDES}
        />

        <br />

        <h3>Invocations</h3>

        {invocations.map((invocation, i) => {
          return (
            <div key={invocation.id}>
              {invocation.url.slice(8)} -{" "}
              <a
                href={`/admin/invocation/${invocation.id}`}
                target="_blank"
              >
                View
              </a>{" "}
              - {moment(invocation.createdAt).fromNow()}
            </div>
          );
        })}

        <br />
        <br />

        <h3>Other</h3>

        <div>
          <a
            onClick={async e => {
              await confirmAction({
                title: "Replace all scenes",
                message: "Are you sure? This will delete all scenes and replace them with 18 new ones. This is for testing purposes only.",
                actionLabel: "Replace scenes",
                destructive: true
              }, async () => {
                const scenes = [];
                setScenes(draft => {
                  // Clear out the draft
                  Object.keys(draft).forEach(key => {
                    delete draft[key];
                  });
                  for (let i = 0; i < 18; i++) {
                    // Make a new id
                    const id = makeId(6);

                    // Add the scene
                    draft[id] = {
                      title: "Scene " + i,
                      contents: generateRandomWords(),
                      commands: generateRandomList(),
                      section: 1,
                      scene: 1,
                      id: id
                    };
                  }
                });
              });
            }}
          >
            Make 18 scene contents
          </a>
        </div>
        <div>
          <br />
          <h3>Load Current Story Bible</h3>
          <button onClick={() => setUserStoryEngine(currentStoryEngine)}>Load</button>
        </div>
        <div>
          <br />
          <h3>Load User Invocation</h3>
          <input
            type="text"
            value={userInvocationId}
            onInput={(e) => setUserInvocationId(e.target.value)}
          ></input>
          <button onClick={() => loadInvocation()}>Load Story Bible</button>
          {userStoryEngine && <button onClick={() => pasteStoryEngine()}>Paste into StoryEngine</button>}
        </div>

        <br />
        {userStoryEngine && (
          <>
            <div>
              <textarea>{JSON.stringify(userStoryEngine)}</textarea>
            </div>
            <br />
            <div className="test-functions">
              <h3>Generate Completions</h3>
              <Select
                className={"select endpoint-select"}
                value={endpoint}
                onChange={(selectedOption) => {
                  setEndpoint(selectedOption);
                }}
                options={ENDPOINTS}
              />
              <input
                type="number"
                value={numFunctionsToTest}
                step={1}
                min={1}
                onChange={(e) => {
                  console.log(e.target.value);
                  setNumFunctionsToTest(e.target.value);
                }}
              />

              <button
                onClick={() => testFunctions(numFunctionsToTest, endpoint)}
                className="submit-function-test"
              >
                Test
              </button>
            </div>
            <div className="test-results">
              {Object.values(testResults).map((res, index) => {
                return (
                  <>
                    <h3 className="test-results-header">Result #{index + 1}</h3>
                    <div className="test-results-card">{Utils.nl2br(res)}</div>
                  </>
                );
              })}
            </div>
          </>
        )}
        <div>
          <h3>Import a Story Bible JSON</h3>
          <textarea
            onInput={(e) => setImportedStoryEngine(e.target.value)}
            value={importedStoryEngine}
          ></textarea>
          {importedStoryEngine && <button onClick={() => pasteStoryEngine(importedStoryEngine)}>Import</button>}
        </div>
        <div>{errorMessage}</div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </StyledContainer>
    </Modal>
  );
}
